/*
 * Furnish My Space page: the before / after slider (sections/pv-private-room-preview.liquid).
 * A native range input drives --pos, so mouse, touch and keyboard all work.
 */
(function () {
  document.querySelectorAll('[data-pv-compare]').forEach(function (figure) {
    var range = figure.querySelector('[data-pv-compare-range]');
    if (!range) return;
    var update = function () {
      figure.style.setProperty('--pos', range.value + '%');
    };
    range.addEventListener('input', update);
    update();
  });
})();
